import { LAYERS, PLACEMENT_DOWN_SEQUENCE, DOWN_PLACEMENTS, DISTANCE } from 'bloko/blocks/drop/constants';

export const ANIMATION_TIMEOUT_MS = 32;
export const ARROW_SIZE = 5;

export const PLACEMENT_INFO_SEQUENCE = PLACEMENT_DOWN_SEQUENCE;

export const INFO_PLACEMENTS = DOWN_PLACEMENTS;

export const THEMES = {
    light: 'light',
    dark: 'dark',
    bright: 'bright',
    info: 'info',
};

export default {
    theme: THEMES.dark,
    layer: LAYERS.aboveContent,
    placement: INFO_PLACEMENTS.bottomStart,
    onClose: () => {},
    showCloseButton: true,
    closeByClickOutside: true,
    dataQa: 'bloko-drop-info',
};

export const BASE_CLASS_NAME = 'bloko-drop_info';

export const BEHAVIOR = {
    showArrow: true,
    arrowSize: ARROW_SIZE,
    setupFullWidthOnXS: false,
    placementOffset: DISTANCE + ARROW_SIZE,
    alignToActivatorBorders: false,
};
